<template>
    <div class="info-banner-wrapper">
        <div class="container">
            <section
                class="info-banner"
                role="note"
                aria-label="Engine oil selection notice"
            >
                <span class="accent" aria-hidden="true"></span>
                <div class="content">
                    <h2 class="title">
                        Make sure you choose the right engine oil for your vehicle!
                    </h2>
                    <p class="message">
                        Failing to use the right oil grade can cause damage to the engine.
                    </p>
                </div>
            </section>
        </div>
    </div>
</template>

<style scoped lang="sass">
    @use "@sass/index" as *

    .info-banner-wrapper
        background: $grey-3

        .info-banner
            display: flex
            align-items: center
            gap: 16px
            padding: 28px 0

            .accent
                position: relative
                width: 27px
                height: 28px
                flex: 0 0 27px
                color: $primary
                font-family: $proxima

                +respond-below(md)
                    height: 28px;
                    align-self: flex-start;

                &::before
                    content: ""
                    position: absolute
                    inset: 0
                    background-repeat: no-repeat
                    background-position: center
                    background-size: contain
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='27' height='28' viewBox='0 0 27 28' fill='none'%3E%3Cpath d='M21.1045 0H26.7878L18.187 28H12.6173L21.1045 0Z' fill='currentColor'/%3E%3Cpath d='M8.48714 0H14.1705L5.56969 28H0L8.48714 0Z' fill='currentColor'/%3E%3C/svg%3E")

                    +respond-below(md)
                        background-position: top

            .content
                display: grid
                gap: 0

                +respond-below(md)
                    gap: 10px

                    .title,
                    .message
                        line-height: 1.2 !important

                .title
                    margin: 0
                    font-size: 16px
                    line-height: normal
                    font-weight: 700
                    color: $primary
                    font-family: $proxima

                .message
                    margin: 0
                    font-size: 14px
                    line-height: normal
                    font-weight: 400
                    color: $primary
                    font-family: $proxima
</style>